// YNX — PWA Install Prompt (bottom-sheet banner, dismissible).
// Shown on Android/Chrome via beforeinstallprompt + iOS hint (manual A2HS).
import React, { useEffect, useState } from 'react';
import { Download, Share2, X, Smartphone } from 'lucide-react';
import {
  onInstallAvailability, promptInstall, dismissInstall,
  wasRecentlyDismissed, isIOS, isStandalone,
} from '../lib/pwa-install';
import './pwa.css';

export const PWAInstallPrompt = () => {
  const [available, setAvailable] = useState(false);
  const [showIOS, setShowIOS] = useState(false);
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    if (isStandalone()) return;          // already installed → nothing to show
    if (wasRecentlyDismissed()) return;  // user said no within 30d

    if (isIOS()) {
      // No native API on iOS; show manual hint after 4s of engagement.
      const t = setTimeout(() => { setShowIOS(true); setHidden(false); }, 4000);
      return () => clearTimeout(t);
    }
    // Android/Chrome path
    const unsub = onInstallAvailability((flag) => {
      setAvailable(flag);
      if (flag) setHidden(false);
    });
    return () => unsub();
  }, []);

  if (hidden) return null;

  const handleInstall = async () => {
    const outcome = await promptInstall();
    if (outcome === 'dismissed') dismissInstall();
    setHidden(true);
  };

  const close = () => {
    dismissInstall();
    setHidden(true);
  };

  return (
    <div className='pwa-banner' role='dialog' aria-label='Installer YNX' data-testid='pwa-install-banner'>
      <div className='pwa-banner-icon' aria-hidden>
        <Smartphone size={20} />
      </div>
      <div className='pwa-banner-body'>
        <div className='pwa-banner-title'>Installer YNX sur cet appareil</div>
        {showIOS ? (
          <div className='pwa-banner-desc'>
            Sur iPhone/iPad : appuyez sur <Share2 size={12} style={{ verticalAlign: '-2px' }} />
            « Partager » puis <b>« Sur l’écran d’accueil »</b>.
          </div>
        ) : (
          <div className='pwa-banner-desc'>
            Accédez à votre espace en un clic, hors-ligne et plein écran.
          </div>
        )}
      </div>
      <div className='pwa-banner-actions'>
        {!showIOS && available && (
          <button className='biz-btn-primary sm' onClick={handleInstall} data-testid='pwa-install-btn'>
            <Download size={12} /> Installer
          </button>
        )}
        <button className='biz-icon-btn pwa-close' onClick={close} title='Plus tard' data-testid='pwa-dismiss-btn'>
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
